import { UserDetails } from '@unistocks/features/admin/components/user-management/user-details';
import { t } from '@unistocks/shared/localization/index.ts';
import { useLocalSearchParams } from 'expo-router';
import Head from 'expo-router/head';

export default function UserDetailsScreen() {
  const { id } = useLocalSearchParams<{ id: string }>();

  return (
    <>
      <Head>
        <title>{t('AbpIdentity::Users')}</title>
      </Head>
      <UserDetails id={id} />
    </>
  );
}
